import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import { UserService } from '../../../service/user/user.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';

import { DataSource } from '../../../classes/dataSource/dataSource';
import { ExportData } from '../../../classes/exportData/exportData';
import { config } from '../../../util/config';
import { isAuthority } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-wa9001',
  templateUrl: 'wa9001.component.html',
  styleUrls: ['wa9001.component.scss']
})
export class Wa9001Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9001:ユーザマスタ照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  public userEditData: object = [];
  public componentTitle9003 = 'WA9003:ユーザマスタ更新';

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private isEnableClearFilterButton = false;
  private selectedCount = 0;
  private delete: boolean = false;
  private isShowWa9002 = false;
  private isShowWa9003 = false;

  private isShowSendLoading = false;

  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isShowLoginModal = false;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  constructor(private router: Router, private userService: UserService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      enableRangeSelection: true,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      // rowModelType: 'normal',
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9001_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.errorInfo = '';
        this.gridHelper.onGridFilterChanged();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        this.selectedCount = 0;
        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        // headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: 'left',
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        headerCheckboxSelection: false
        // suppressMenu: true
        //lockPosition: true
      },
      {
        headerName: 'ユーザコード',
        field: 'userCd',
        sort: 'asc',
        width: this.getColumnWidth('userCd', 140),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ユーザ名',
        field: 'userTx',
        width: this.getColumnWidth('userTx', 160),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '論理倉庫',
        field: 'logicalWhTx',
        width: this.getColumnWidth('logicalWhTx', 140),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      // {
      //   headerName: '使用言語',
      //   field: 'langTx',
      //   width: this.getColumnWidth('langTx', 200)
      // },
      {
        headerName: '権限',
        field: 'roleTx',
        width: this.getColumnWidth('roleTx', 140),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '紐づき荷主',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 160),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin - 20;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa9001_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9001_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9001_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa9001_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  getContextMenuItems(params) {
    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              ExportData.toCsv(params.api);
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin - 20;
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    this.isShowWa9002 = false;
    this.isShowWa9003 = false;
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, 500);

    const loginResult = JSON.parse(sessionStorage.getItem('loginResult'))
    let isOperatorUser = loginResult.user.roleId === 2;

    if (!isAuthority('wa9001') || isOperatorUser) {
      // 権限 システム管理者/業務管理者 以外は、エラー
      this.errorInfo = this.componentTitle + 'は、管理者権限が必要です';
      this.router.navigate([
        JSON.parse(sessionStorage.getItem('loginResult')).user.roleId === 3  
        ? 'wa0003' : 'wa0002']);
      return;
    }
  }

  onView() {
    this.onSubmit();
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
  if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    sessionStorage.removeItem('useredit');
    sessionStorage.removeItem('userpasswd');
    this.onFilterClear();

    this.userService
      .get()
      .then(outputJson => {
        this.rowData = outputJson.users;
        //this.gridOptions.api.setRowData(this.rowData);
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  reg() {
    this.isShowWa9002 = true;
  }

  edit() {
    const result = sessionStorage.getItem('loginResult');
    let user;
    if (result !== null) {
      const resultObject = JSON.parse(result);
      user = resultObject.user;
    } else {
      sessionStorage.clear();
      this.router.navigate(['wa0001']);
      return;
    }

    if (user.roleId >= 2) {
      // 権限 システム管理者/業務管理者 以外は、エラー
      this.errorInfo = this.componentTitle9003 + 'は、管理者権限が必要です';
      // this.router.navigate(['wa0002']);
      return;
    }


    sessionStorage.setItem('useredit', this.gridOptions.api.getSelectedNodes()[0]['data']['userId']);

    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    this.userEditData = this.rowData[selectedIndex];
    this.isShowWa9003 = true;
  }

  del() {
    this.errorInfo = '';
    this.isShowSendLoading = true;
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    //SWMS-1184対応 ログイン情報取得
    const result = sessionStorage.getItem('loginResult');
    let userId: string;
    if (result !== null) {
      const resultObject = JSON.parse(result);
      userId = resultObject.user.userId;
    } else {
      this.dialogsService
        .info('エラー', 'ログイン情報が不正です');
      this.working = false;
      return;
    }

    if (this.gridOptions.api.getSelectedNodes().length == 0) {
      this.errorInfo = '1つ対象を選択して下さい';
      this.isShowSendLoading = false;
      this.working = false;
      //SWMS-1186対応
      this.delete = false;
      return;
    }

    if (this.gridOptions.api.getSelectedNodes().length > 1) {
      this.errorInfo = '1つ対象を選択して下さい';
      this.isShowSendLoading = false;
      this.working = false;
      //SWMS-1186対応
      this.delete = false;
      return;
    }
    //SWMS-1184対応
    if(this.gridOptions.api.getSelectedNodes()[0]['data']['userId'] === userId){
      this.errorInfo = 'ログインに使用しているユーザーは削除できません。';
      this.isShowSendLoading = false;
      this.working = false;
      //SWMS-1186対応
      this.delete = false;
      return;
    }

    this.userService
      .delete(this.gridOptions.api.getSelectedNodes()[0]['data']['userId'])
      .then(outputJson => {
        this.isShowSendLoading = false;
        this.working = false;
        this.onSubmit();
        this.delete = false;
      })
      .catch(error => {
        this.isShowSendLoading = false;
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.delete = false;
      });
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onClose9002(isRefreshGrid: boolean) {
    this.isShowWa9002 = false;
    if (isRefreshGrid) this.onSubmit();
  }
  onClose9003(isRefreshGrid: boolean) {
    this.isShowWa9003 = false;
    if (isRefreshGrid) this.onSubmit();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9001/wa9001.component.ts